module.exports = function (assocIdx, assoc, attrName) {
  if (assocIdx !== null) {
    /*
    We can't do an exact match because sometimes the "index" is a `timestamp, or items are reordered.
    We can't match on `id` because we'll match extra inputs, e.g. "lease_rate" will match "hide_lease_rate".
    Using `name` will avoid this.
    */

    let formattedAttrName = `[${attrName}]`;
    if (attrName.includes('.')) {
      formattedAttrName = attrName.split('.').map((attr, index) => {
        if (index === 0) return `[${attr}_attributes]`;

        return `[${attr}]`;
      }).join('');
    }
    return $(
      $(`[name^="property[${assoc}_attributes]"][name$="${formattedAttrName}"]`)[assocIdx]
    );
  } else if (assoc) {
    // Matching on ID won't work for "state" because 2 elements share the ID
    return $(`[name^="property[${assoc}_attributes][${attrName}]"]`);
  } else if (attrName) {
    return $('#property_' + attrName);
  }
};
